const methodBlacklist = ['post', 'put'];

const apiRequests = {
  requests: {},

  get(url) {
    return apiRequests.requests[encodeURIComponent(url)];
  },

  delete: (url) => {
    if (apiRequests.requests[encodeURIComponent(url)]) {
      delete apiRequests.requests[encodeURIComponent(url)];
    }
  },

  set: (config) => {
    const method = (config.method || '').toLowerCase();
    if (methodBlacklist.includes(method) || config.alwaysAllowRequest) {
      return;
    }
    apiRequests.requests[encodeURIComponent(config.url)] = apiRequests.requests[encodeURIComponent(config.url)] || {
      cancel: (config.cancelSource || {}).cancel,
      pathname: window.location.pathname,
    };
  },

  isAllowed: (config) => {
    const method = (config.method || '').toLowerCase();
    if (methodBlacklist.includes(method || config.alwaysAllowRequest)) {
      return true;
    }
    return !apiRequests.get(config.url);
  },

  cancelByPathname(currentPath) {
    Object.entries(apiRequests.requests).forEach(([key, n]) => {
      if (typeof n.cancel === 'function' && currentPath !== n.pathname) {
        n.cancel();
        delete apiRequests.requests[key];
      }
    });
  },
};

export default apiRequests;
